//region 1. Platform Libraries
import { assert } from 'chai';
//endregion

//region 2. Project Libraries
import DataAPI, { logger } from './DataAPI';
//endregion

//region T. Tests
describe('Initialization', () => {
    it('should initialize with options', () => {
        const dataAPI = new DataAPI();
        const initResult = dataAPI.initialize({
            environment: 'unit-test',
            heartbeatInterval: 42,
            logglySubdomain: process.env.CLIO_LOGGLY_SUBDOMAIN,
            logglyToken: process.env.CLIO_LOGGLY_TOKEN,
            logLevel: 'ERROR',
            mongoUrl: process.env.CLIO_MONGO_URL,
            port: 15926,
        });
        assert.equal(true, initResult);
        assert.equal('unit-test', dataAPI.environment);
        assert.equal(42, DataAPI.heartbeatInterval);
        assert.equal(true, !!logger);
        assert.deepEqual(['console', 'dailyRotateFile', 'loggly'],
            Object.keys(logger.transports));
        assert.equal('ERROR', dataAPI.logLevel.name);
        assert.equal(process.env.CLIO_MONGO_URL, dataAPI.mongoUrl);
        assert.equal(15926, dataAPI.port);
    });

    it('should initialize without options', () => {
        const dataAPI = new DataAPI();
        assert.equal(true, dataAPI.initialize());
        assert.equal('', dataAPI.environment);
        assert.equal(10, DataAPI.heartbeatInterval);
        assert.equal(true, !!logger);
        assert.deepEqual(['console', 'dailyRotateFile'],
            Object.keys(logger.transports));
        assert.equal('DEBUG', dataAPI.logLevel.name);
        assert.equal('mongodb://localhost', dataAPI.mongoUrl);
        assert.equal(15925, dataAPI.port);
    });

    it('should return false if initialize with heartbeat interval of 0', () => {
        assert.equal(false, new DataAPI().initialize({ heartbeatInterval: 0 }));
    });

    it('should return false if initialize with Mongo URL of invalid scheme', () => {
        assert.equal(false, new DataAPI().initialize({ mongoUrl: 'invalid://localhost' }));
    });

    it('should return false if initialize with out of range port', () => {
        assert.equal(false, new DataAPI().initialize({ port: -1 }));
        assert.equal(false, new DataAPI().initialize({ port: 0 }));
        assert.equal(false, new DataAPI().initialize({ port: 70000 }));
    });
});

//endregion
